/* eslint-disable no-console */
import { config } from 'config';
import * as lscache from 'lscache';

export const extractErrorString = (errorObj: {
  graphQLErrors?: { message: string }[];
  message?: string;
}): string => {
  let errorString = '';
  if (errorObj.graphQLErrors !== undefined) {
    const errorArr = errorObj.graphQLErrors;
    errorArr.forEach((e) => {
      errorString = errorString + e.message + '\n';
    });
  }

  // If errorString not present then get the errorObj.message
  return errorString || errorObj.message || '';
};

/**
 * Check if the local-storage and cookie-storage is to be cleared depending on the value set in the
 * `REACT_APP_CACHE_CLEAR_TIMESTAMP` env variable.
 *
 * If the value set for above key in the `process.env` is greater than the value stored in a same-named
 * local-storage key, it will result in clearing of all cookies (JS only) and local-storages of the browser for the current
 * domain.
 */
export const checkAndClearCache = (): void => {
  const currentCacheClearTimestamp = config.cacheClearTimestamp;
  const lastCacheClearTimestamp = parseInt(
    lscache.get('cacheClearTimestamp') ?? '-1',
  );
  if (currentCacheClearTimestamp > lastCacheClearTimestamp) {
    // Clear all cookies
    clearAllCookies();

    // Clear local-storage
    window.localStorage.clear();

    // Set last cache clearing timestamp
    lscache.set('cacheClearTimestamp', currentCacheClearTimestamp);
  }
};

/**
 * Iterate through all derivable paths and clear the cookies for the current domain.
 * Solution based on the SO answer found at {@link https://stackoverflow.com/a/33366171/2045547}
 */
const clearAllCookies = (): void => {
  try {
    const cookies = document.cookie.split(';');

    for (let cookieIndex = 0; cookieIndex < cookies.length; cookieIndex++) {
      const cookieBase =
        encodeURIComponent(cookies[cookieIndex].trim().split('=')[0]) +
        `=; expires=${new Date(0).toUTCString()}; path=`;
      document.cookie = cookieBase + '/';

      const paths = location.pathname.split('/');
      while (paths.length > 0) {
        document.cookie = cookieBase + paths.join('/');
        paths.pop();
      }
    }
  } catch (error) {
    console.log('An error occurred while clearing all JS cookies');
    console.log(error);
  }
};

/**
 * Clears all the local-storage related to authenticated tenant-admin context.
 */
export const clearAllAuthStorage = (): void => {
  lscache.remove('accessToken');
  lscache.remove('currentTenantName');
  lscache.remove('tenantAdminName');
  lscache.remove('tenantAdminEmail');
  lscache.remove('currentTenantId');
  lscache.remove('signInMethod');
  lscache.remove('switchedFromTenantId');
};
